import { Course } from '../models/interfaces/course.interface';
import { CourseLocation } from '../models/enums/course-location.enum';
import { CourseType } from '../models/enums/course-type.enum';

export interface CourseFacetFilters {
  categoryIds?: string[];
  type?: CourseType | null;
  location?: CourseLocation | null;
  searchTerm?: string;
}

export function matchesCourseFacets(
  course: Pick<Course, 'title' | 'description' | 'categoryId' | 'category' | 'type' | 'location'> | undefined,
  filters: CourseFacetFilters,
): boolean {
  if (!course) {
    return !filters.searchTerm?.trim()
      && !filters.categoryIds?.length
      && !filters.type
      && !filters.location;
  }

  if (filters.searchTerm?.trim()) {
    const term = filters.searchTerm.trim().toLowerCase();
    const title = course.title?.toLowerCase() ?? '';
    const description = course.description?.toLowerCase() ?? '';

    if (!title.includes(term) && !description.includes(term)) {
      return false;
    }
  }

  if (filters.categoryIds?.length) {
    const courseCategoryId = course.categoryId ?? course.category?.id;
    if (!courseCategoryId || !filters.categoryIds.includes(courseCategoryId)) {
      return false;
    }
  }

  if (filters.type && course.type !== filters.type) {
    return false;
  }

  if (filters.location && course.location !== filters.location) {
    return false;
  }

  return true;
}

export function appendCourseFilterParams(
  params: URLSearchParams,
  filters: CourseFacetFilters & { tab?: string },
): void {
  if (filters.searchTerm?.trim()) {
    params.set('searchTerm', filters.searchTerm.trim());
  }

  if (filters.categoryIds?.length) {
    params.set('categoryIds', filters.categoryIds.join(','));
  }

  if (filters.type) {
    params.set('type', filters.type);
  }

  if (filters.location) {
    params.set('location', filters.location);
  }

  if (filters.tab) {
    params.set('tab', filters.tab);
  }
}
